<template>
  <div class="page">
    <div
      class="list"
      v-if="list && list.length > 0"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <div v-for="(item, index) in list" :key="index" @click="selectItem(item)">
        <activity-item
          :value="item"
          :select-id="(selectInfo && selectInfo.id) || ''"
        />
      </div>
      <div class="empty" />
    </div>
    <div v-if="list && list.length == 0" class="empty-placeholder">
      <empty-placeholder empty-txt="暂无数据" />
    </div>
    <div v-if="list && list.length > 0" class="button-wrapper">
      <div class="button" @click="submitSend">确定</div>
    </div>
  </div>
</template>
<script>
import { KMAApi } from "../../utils/http";
import { mapGetters } from "vuex";
import { Toast, Indicator } from "mint-ui";
import activityItem from "../../components/kma/activity-item";
import EmptyPlaceholder from "../../components/empty-placeholder";
export default {
  name: "KmaActivity",
  components: {
    activityItem,
    EmptyPlaceholder,
  },
  data() {
    return {
      list: null,
      loading: false,
      selectInfo: null, // 选中的活动
      params: {
        pageIndex: 1,
        pageSize: 4,
      },
      totalNum: 0,
      isLoading: false, // 是否加载中
      butDisabled: false, // 是否禁用按钮
    };
  },
  created() {
    this._getActivitys();
  },
  computed: {
    ...mapGetters(["userID"]),
  },
  methods: {
    /** 获取活动列表 */
    async _getActivitys() {
      const res = await KMAApi.getCompanyManuscript({
        businessId: this.$route.query.businessId,
        ...this.params,
      });
      if (res.status === 0) {
        this.totalNum = res.data.total;
        this.list = (this.list || []).concat((res.data && res.data.list) || []);
      }
      this.isLoading = false;
    },
    loadMore() {
      if (!this.isLoading && this.list && this.list.length < this.totalNum) {
        this.isLoading = true;
        this.params.pageIndex++;
        this._getActivitys();
      }
    },
    /** 选择活动 */
    selectItem(item) {
      if (this.selectInfo && this.selectInfo.id == item.id) {
        this.selectInfo = null;
      } else {
        this.selectInfo = item;
      }
    },
    /** 确认发送 */
    submitSend() {
      if (this.butDisabled) {
        return;
      }
      this.butDisabled = true;
      if (this.selectInfo) {
        Indicator.open({
          text: "发送中...",
          spinnerType: "fading-circle",
        });
        this.$store
          .dispatch("putMaterialInfo", {
            data: "activity",
            description: JSON.stringify(this.selectInfo),
            extension: "",
          })
          .then(() => {
            Indicator.close();
            Toast({
              message: "发送成功",
              duration: 2500,
            });
            this.$router.go(-1);
          })
          .catch((error) => {
            Indicator.close();
            this.$store.commit("showMessage", {
              type: "error",
              message: error.message,
            });
            this.$router.go(-1);
          });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
}
.list {
  display: flex;
  flex-flow: column;
  width: 7.5rem;
  height: calc(100vh - 55px - (env(safe-area-inset-bottom) / 2));
  overflow-y: auto;
  background: #f7f8fa;
  .empty {
    height: 0.2rem;
    width: 100%;
    flex-shrink: 0;
  }
}
.empty-placeholder {
  height: 100vh;
  width: 100vw;
  background: #ffffff;
}
.button-wrapper {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7.5rem;
  height: 55px;
  box-shadow: 0px -2px 12px rgba(100, 101, 102, 0.12);
  background-color: #ffffff;
  .button {
    width: 86%;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background: #07c160;
    font-size: 0.32rem;
    border-radius: 20px;
  }
}
</style>